import { conditions } from "helpers";
import { ConditionName, SettingSections } from "interfaces";
import { qualityChangeRequestLog, sendFluentLog } from "../../../../../logs";
import { createSettings } from "redux-share/actions/user.actions";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { setActiveElements } from "redux-share/slices/controllerSlice";
import { setSettingPopover } from "redux-share/slices/popoversSlice";
import { setUserSettings } from "redux-share/slices/userSlice";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";
import { memo } from "react";

const ChevronRightIcon = dynamic(() => import("../../icon-components/chevronRight"));

const QualityLevels = ({ setSection }: any) => {
    const dispatch = useAppDispatch();
    let { qualityLevels, qualityBitrates } = useAppSelector(
        ({ controller: { qualityLevels, qualityBitrates, manualQuality, autoQuality, showMiniPlayer } }) => ({
            qualityLevels,
            qualityBitrates,
            manualQuality,
            autoQuality,
            showMiniPlayer
        }),
        shallowEqual
    );
    const { settings } = useAppSelector(({ user: { settings } }) => ({ settings }), shallowEqual);
    useAppSelector(({ videoData: { params, videoElementSizeInfo } }) => ({ params, videoElementSizeInfo }), shallowEqual);

    qualityLevels = [-1, ...qualityLevels];

    const handleTickSelectedQuality = (index: number, qualityLevel: number) => {
        if (conditions(ConditionName.isAutoQuality) && qualityLevel === -1) return true;
        else return !conditions(ConditionName.isAutoQuality) && settings.quality === index;
    };

    return (
        <div id={SettingSections.qualityLevels} className="animate__animated animate__fadeIn pl-p-[14px]">
            <div
                className={`pl-flex pl-items-center pl-gap-2 pl-pb-3 pl-mb-3 pl-border-b pl-border-b-gray-300 dark:pl-border-b-dark-4 pl-cursor-pointer`}
                onClick={() => setSection(SettingSections.main)}
            >
                {!conditions(ConditionName.showMiniPlayer) && (
                    <div className={`pl-rounded-[4px] pl-p-1 pl-bg-gray-300 dark:pl-bg-dark-4`}>
                        <ChevronRightIcon className={`pl-w-3 pl-h-3 pl-stroke-gray-800`} />
                    </div>
                )}
                <p className={`pl-text-[15px] pl-font-medium ${conditions(ConditionName.isMiniPlayer) && "pl-relative pl-right-3"}`}>کیفیت</p>
            </div>
            <ul className="pl-flex pl-flex-col">
                {qualityLevels.map((qualityLevel: number, index: number) => (
                    <li
                        key={index}
                        className={`pl-flex pl-items-center pl-text-[14px] pl-font-medium pl-rounded-[4px] pl-relative pl-cursor-pointer pl-leading-6 hover:pl-bg-main/[0.1] hover:dark:pl-bg-white/[0.25] pl-p-1 pl-pr-2 ${
                            handleTickSelectedQuality(index - 1, qualityLevel) && "pl-bg-main-light hover:!pl-bg-main-light pl-text-dark-5"
                        }`}
                        onClick={() => {
                            sendFluentLog(qualityChangeRequestLog(qualityLevel === -1 ? "auto" : `${qualityLevel}P`));
                            dispatch(setActiveElements(false));
                            dispatch(setSettingPopover(false));
                            dispatch(setUserSettings({ ...settings, quality: qualityLevel === -1 ? -1 : index - 1 }));
                            createSettings({ ...settings, quality: qualityLevel === -1 ? null : index - 1 });
                            setSection(SettingSections.main);
                        }}
                    >
                        <span className="pl-w-full">
                            {qualityLevel === -1 ? "خودکار (بر اساس سرعت اینترنت شما)" : `${qualityLevel}P - ${qualityBitrates[index]}`}
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default memo(QualityLevels);
